import React from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import HomeIcon from '@mui/icons-material/Home';
import { ACTIVE_MODULE_LABELS } from '../lib/companyActiveModules';

/**
 * Shown when a user navigates to a dashboard section their tenant has not purchased.
 */
export default function ModuleNotActive({
  moduleKey,
  moduleLabel,
  onGoHome,
}) {
  const label = moduleLabel || ACTIVE_MODULE_LABELS[moduleKey] || 'This module';

  return (
    <Box sx={{ maxWidth: 560, mx: 'auto', py: { xs: 4, sm: 8 } }}>
      <Paper variant="outlined" sx={{ p: { xs: 3, sm: 4 }, textAlign: 'center' }}>
        <LockOutlinedIcon color="disabled" sx={{ fontSize: 48, mb: 2 }} />
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 700 }}>
          Module not active
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 1 }}>
          <strong>{label}</strong> is not enabled for your organization.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Contact your platform administrator or upgrade your plan to unlock this part of the
          Business App Hub.
        </Typography>
        {onGoHome && (
          <Button variant="contained" startIcon={<HomeIcon />} onClick={onGoHome}>
            Back to overview
          </Button>
        )}
      </Paper>
    </Box>
  );
}
